// 初始分页信息
export const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
}

export default {
  data() {
    return {
      page: { ...initPage },
    }
  },
  methods: {
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.reload({ isReset: false })
    },
    resetPage(page = {}) {
      this.page = { ...initPage, ...page }
    },
  },
}
